import { Ticket } from "../types/entities/ticket"

const STORAGE_KEY = "ck-order-payment-methods"

export type OrderPaymentMethodSlug = "card" | "sbp" | "sberpay" | "pushkin_card"

type Stored = Record<string, OrderPaymentMethodSlug>

function read(): Stored {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        return raw ? (JSON.parse(raw) as Stored) : {}
    } catch {
        return {}
    }
}

function write(data: Stored) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

export function normalizePaymentMethodSlug(slug: string): OrderPaymentMethodSlug | null {
    const normalized = slug.trim().toLowerCase()
    if (normalized === "card") return "card"
    if (normalized === "sbp") return "sbp"
    if (normalized === "sberpay") return "sberpay"
    if (normalized === "pushkin" || normalized === "pushkin_card") return "pushkin_card"
    return null
}

export function saveOrderPaymentMethod(orderId: string, method: OrderPaymentMethodSlug | string) {
    const slug = typeof method === "string" ? normalizePaymentMethodSlug(method) : method
    if (!slug) return
    const data = read()
    data[orderId] = slug
    write(data)
}

export function getOrderPaymentMethod(orderId: string): OrderPaymentMethodSlug | null {
    return read()[orderId] ?? null
}

export function clearOrderPaymentMethod(orderId: string) {
    const data = read()
    if (!(orderId in data)) return
    delete data[orderId]
    write(data)
}

export function resolveOrderPaymentMethod(ticket: Ticket): OrderPaymentMethodSlug | null {
    const stored = getOrderPaymentMethod(ticket.id)
    if (stored) return stored

    const fromInfo = ticket.payment_info?.method_slug
    if (fromInfo) {
        const slug = normalizePaymentMethodSlug(fromInfo)
        if (slug) return slug
    }

    return null
}

export const ORDER_PAYMENT_METHOD_LABELS: Record<OrderPaymentMethodSlug, string> = {
    card: "Банковская карта",
    sbp: "СБП",
    sberpay: "SberPay",
    pushkin_card: "Пушкинская карта",
}
